import React, { useContext, useEffect, useState } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import Context, { IContext } from '../../context/Context';
import api, { definirTenant } from '../../services/api';

// Rota pai /:cnpj/:filial. Define o tenant dos headers da API (X-Client-ID e
// X-Filial-NAME) e só renderiza as telas depois que a API confirma a empresa.
function ValidaEmpresa() {
  const navigate = useNavigate();
  const { cnpj = '', filial = '' } = useParams();
  const { setEmpresa, setIsLoadingOverlay }: IContext = useContext(Context);
  const [validada, setValidada] = useState(false);

  function recusar(mensagem: string) {
    toast.error(mensagem);
    navigate('/erro', { replace: true });
  }

  async function validar(cancelado: () => boolean) {
    setValidada(false);
    setEmpresa(undefined);

    if (!/^\d{14}$/.test(cnpj)) {
      recusar('CNPJ inválido na URL, verifique o endereço.');
      return;
    }

    try {
      setIsLoadingOverlay(true);
      definirTenant(cnpj, filial);

      const response = await api.get('/tenant');

      if (cancelado()) return;
      setEmpresa({ raz: response.data.raz, fil: response.data.fil, cnpj, grade: response.data.grade === '1' });
      setValidada(true);
    } catch (error: any) {
      if (cancelado()) return;
      if (error.response?.data?.MENSAGEM) return recusar(error.response.data.MENSAGEM);
      if (!error.response) return recusar('Não foi possível conectar ao servidor.');
      recusar('Empresa não encontrada, verifique o CNPJ e a filial.');
    } finally {
      setTimeout(() => setIsLoadingOverlay(false), 200);
    }
  }

  useEffect(() => {
    let cancelado = false;
    validar(() => cancelado);

    return () => {
      cancelado = true;
    };
  }, [cnpj, filial]);

  if (!validada) return <></>;

  // key: ao trocar de empresa, as telas montam de novo e buscam menu e dados do novo tenant
  return <Outlet key={`${cnpj}/${filial}`} />;
}

export default ValidaEmpresa;
